export const normalizeRiskAssessmentListValue = (value: string): string => {
  const normalized = value
    .split(/\s*(?:,|[;；]|\s\/\s|\r?\n)\s*/)
    .map((item) => item.trim())
    .filter((item) => item && item !== "-");

  return normalized
    .filter((item, index) => normalized.indexOf(item) === index)
    .join(", ");
};

export const parseRiskAssessmentListValue = (value: string): string[] => {
  const normalized = normalizeRiskAssessmentListValue(value);
  return normalized ? normalized.split(", ") : [];
};
